import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { makeStyles, darken } from '@material-ui/core/styles';
import classNames from 'classnames';

import { useContent } from 'hooks';
import { CustomSVG, ICustomSVG } from 'components';
import { Events } from 'analytics';

import { ExternalLink } from './index';
import { getNetwork } from '../helpers';

const useStyles = makeStyles(theme => ({
  button: {
    padding: theme.spacing(0.5, 2),
    color: theme.palette.common.white,
    border: 'none',
    borderRadius: theme.spacing(4),
  },
  twitter: {
    backgroundColor: theme.custom.networks.twitter,

    '&:hover': {
      backgroundColor: darken(theme.custom.networks.twitter, 0.1),
    },
  },
  linkedin: {
    backgroundColor: theme.custom.networks.linkedin,

    '&:hover': {
      backgroundColor: darken(theme.custom.networks.linkedin, 0.1),
    },
  },
  facebook: {
    backgroundColor: theme.custom.networks.facebook,

    '&:hover': {
      backgroundColor: darken(theme.custom.networks.facebook, 0.1),
    },
  },
  youtube: {
    backgroundColor: theme.custom.networks.youtube,

    '&:hover': {
      backgroundColor: darken(theme.custom.networks.youtube, 0.1),
    },
  },
  instagram: {
    ...theme.custom.networks.instagram,
    borderRadius: 16,

    '&:hover': {
      opacity: '1.1',
    },
  },
}));

const Engage: FC = () => {
  const classes = useStyles();
  const content = useContent();
  const { t } = useTranslation();
  const network = getNetwork(content);
  const networkLowercase = network.toLowerCase();
  const networkIconName = `${networkLowercase}Rounded`;

  if (!content.is_engageable) {
    return null;
  }

  function handleTracking() {
    analytics.track(Events.ClickEngage, {
      content_id: content.content_id,
      linkedin: networkLowercase === 'linkedin',
      twitter: networkLowercase === 'twitter',
      facebook: networkLowercase === 'facebook',
      instagram: networkLowercase === 'instagram',
      youtube: networkLowercase === 'youtube',
    });
  }

  return (
    <ExternalLink>
      <Button
        variant="contained"
        onClick={handleTracking}
        className={classNames(classes.button, classes[networkLowercase])}
        endIcon={<CustomSVG name={networkIconName as keyof ICustomSVG} size={16} />}>
        {t(`common:engage`)}
      </Button>
    </ExternalLink>
  );
};

export default Engage;
